/* eslint-disable prefer-object-spread */
import { createReducer } from 'reduxsauce';
import Types from '../Actions/Types';

export const INITIAL_STATE = {
	fetchingPremiumDiscountChart: false,
	chartData: {}
};

const requestPremiumDiscountChart = state => {
	return Object.assign({}, state, {
		fetchingPremiumDiscountChart: true
	});
};

const receivePremiumDiscountChart = (state, action) => {
	return Object.assign({}, state, {
		fetchingPremiumDiscountChart: false,
		chartData: action.response.data
	});
};

/**
 * Called by the saga in the finally block to ensure that in all cases the
 * fetching state for the call is set back to false to avoid infinite loader
 * and the ability to display both loaders and "sorry no data" messages.
 * @param {object} state
 * @param {object} action
 */
const handleLoader = (state, action) => {
	return Object.assign({}, state, {
		[action.fetchName]: false
	});
};

// map our types to our handlers
const ACTION_HANDLERS = {
	[Types.API_CIBC_RECEIVE_PREMIUM_DISCOUNT_CHART]: receivePremiumDiscountChart,
	[Types.API_CIBC_REQUEST_PREMIUM_DISCOUNT_CHART]: requestPremiumDiscountChart,
	[Types.API_CIBC_HANDLE_PREMIUM_DISCOUNT_CHART_LOADER]: handleLoader
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
